import { AnyAction, combineReducers } from "@reduxjs/toolkit";
import { dialogSliceName } from "../features/dialog/dataTypes";
import dialogSlice from "../features/dialog/dialogSlice";
import sessionSlice from "../features/session/sessionSlice";
import { sessionSliceName } from "../features/session/dataTypes";
import { signOut } from "./actions";
import appDataReducer from "./appDataReducer";
import { appDataName } from "./dataTypes";

const combinedReducer = combineReducers({
  [appDataName]: appDataReducer,
  [dialogSliceName]: dialogSlice,
  [sessionSliceName]: sessionSlice,
});

export type RootState = ReturnType<typeof combinedReducer>;

const rootReducer = (state: RootState | undefined, action: AnyAction) => {
  if (signOut.match(action)) {
    state = undefined;
  }

  return combinedReducer(state, action);
};

export default rootReducer;
